import React from 'react';
import RiskOrder from './RiskOrder';

export default function RealOrderPage() {
  return <RiskOrder lockedTradeMode="REAL" />;
}
